import classnames from 'classnames';
import { CKContainerProps } from 'clearkit';
import React, { FC } from 'react';

import { RequestMethod } from './types';

type LogInfoProps = CKContainerProps & {
  requestMethod?: RequestMethod;
  requestPath?: string;
};

export const LogInfo: FC<LogInfoProps> = ({
  className,
  requestMethod,
  requestPath,
  ...rest
}) => {
  return (
    <div {...rest} className={classnames('flex gap-2', className)}>
      <span className="font-medium">{requestMethod}</span>
      <span className="inline-block font-mono text-gray-500 truncate">
        {requestPath}
      </span>
    </div>
  );
};
